import React, {useEffect, useRef, useState} from 'react'
import {Container, StyledMedia} from "../styles/CommonStyler";
import {isMobileOnly} from "react-device-detect";
import {Header} from "../components/Header";
import {uiConstants} from "../_constants";
import Footer from "../components/Footer";
import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import {subscriptionActions} from "../_actions";
import {__isAvailable, __isKeyAvailable, userHelper} from "../_helpers";
import LoaderMessage from "../_components/LoaderMessage";

// COMPONENT ##########################################################

export function SwitchSubscription() {
	
	const {t} = useTranslation("pricing");
	const dispatch = useDispatch();
	
	const isMountedRef = useRef(true);
	const [delayedFunction, setDelayedFunction] = useState(null);
	
	// Function to be called after delay
	const delayedAction = () => {
		if (isMountedRef.current) { initiateSubscribeProcess(); }
	};
	
	// Function to start the delayed action
	const startDelayedAction = () => {
		cancelDelayedAction();  // Cancel any existing delayed action
		// Set up a new delayed action
		const timeoutId = setTimeout(delayedAction, 1000);  // delay
		setDelayedFunction(timeoutId);
	};
	
	// Function to cancel the subscribe action
	const cancelDelayedAction = () => {
		if (delayedFunction) {
			clearTimeout(delayedFunction);
			setDelayedFunction(null); // Clear the reference to the timeout
		}
	};
	
	useEffect(() => {
		startDelayedAction()
		
		// Clean up the timeout when the component unmounts
		return () => {
			isMountedRef.current = false;
			cancelDelayedAction();
		};
	}, []);
	
	const subscriptions = useSelector(state => state.subscriptions)
	const isSubscribeProcessOngoing = __isKeyAvailable(subscriptions, "subscribe", "isLoading")
			? subscriptions.subscribe.isLoading
			: false;
	
	const initiateSubscribeProcess = () => {
		if(!isSubscribeProcessOngoing) {
			const searchParams = new URLSearchParams(window.location.search);
			const planUuid = searchParams.get('uuid');
			const plan = userHelper.getPlanByUuid(planUuid);
			
			if(__isAvailable(plan)) {
				dispatch(subscriptionActions.subscribe(plan));  // start APi calls for switching subscription
			} else {
				window.location.replace('/pricing');            // re-load back to pricing,
			}
		}
	}
	
	return (
			<StyledMedia>
				<Container isMobile={isMobileOnly}>
					
					<Header
							isMobile={isMobileOnly}
							pageTitle={t("Subscribe")}
							screen={uiConstants.HEADER_LANDING_PAGE}/>
					
						{
							LoaderMessage({
								title: '',
								messages: [],
								alert: alert,
								loadingText: t("Subscribing"),
							})
						}
					
					<Footer/>
				
				</Container>
			</StyledMedia>
	);
}